import React, { useState, useRef, useEffect } from 'react'
import './GeminiPage.css'
import { Link } from 'react-router-dom'

const GeminiPage = () => {
  const heroSectionRef = useRef(null)
  const [ripples, setRipples] = useState([])
  
  // Refs para las imágenes y video de la sección
  const image1Ref = useRef(null)
  const image2Ref = useRef(null)
  const image3Ref = useRef(null)
  const videoRef = useRef(null)
  
  // Estados para controlar la visibilidad
  const [isImage1Visible, setIsImage1Visible] = useState(false)
  const [isImage2Visible, setIsImage2Visible] = useState(false)
  const [isImage3Visible, setIsImage3Visible] = useState(false)
  const [isVideoVisible, setIsVideoVisible] = useState(false)
  
  // Intersection Observer para detectar cuando los elementos entran en el viewport
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    }
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target === image1Ref.current) {
            setIsImage1Visible(true)
          } else if (entry.target === image2Ref.current) {
            setIsImage2Visible(true)
          } else if (entry.target === image3Ref.current) {
            setIsImage3Visible(true)
          } else if (entry.target === videoRef.current) {
            setIsVideoVisible(true)
          }
        }
      })
    }, observerOptions)
    
    if (image1Ref.current) observer.observe(image1Ref.current)
    if (image2Ref.current) observer.observe(image2Ref.current)
    if (image3Ref.current) observer.observe(image3Ref.current)
    if (videoRef.current) observer.observe(videoRef.current)
    
    return () => {
      if (image1Ref.current) observer.unobserve(image1Ref.current)
      if (image2Ref.current) observer.unobserve(image2Ref.current)
      if (image3Ref.current) observer.unobserve(image3Ref.current)
      if (videoRef.current) observer.unobserve(videoRef.current)
    }
  }, [])

  const createRipple = (e) => {
    if (!heroSectionRef.current) return

    const rect = heroSectionRef.current.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    // Crear múltiples ondas para un efecto más rico
    for (let i = 0; i < 2; i++) {
      const newRipple = {
        id: Date.now() + i,
        x,
        y,
        delay: i * 150, // Delay entre ondas
      }

      setRipples((prev) => [...prev, newRipple])

      // Remover el ripple después de la animación
      setTimeout(() => {
        setRipples((prev) =>
          prev.filter((ripple) => ripple.id !== newRipple.id),
        )
      }, 1200)
    }
  }

  const handleOpenLink = (url, e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const handleKeyDown = (event, action) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      action(event)
    }
  }

  return (
    <div className="gemini-page">
      {/* Hero Section */}
      <section
        className="hero-section"
        ref={heroSectionRef}
        onMouseMove={createRipple}
      >
        {ripples.map((ripple) => (
          <span
            key={ripple.id}
            className="ripple"
            style={{
              left: `${ripple.x}px`,
              top: `${ripple.y}px`,
              animationDelay: `${ripple.delay}ms`,
            }}
          />
        ))}
        <div className="hero-content">
          <img
            style={{ width: '30vw', height: 'auto', marginBottom: '20px' }}
            src="https://storage.googleapis.com/lucia-static/media/img/Captura%20de%20pantalla%202025-12-15%20a%20la(s)%202.39.08%E2%80%AFp.m..png"
            alt="Gemini Logo"
          />

          {/* <h1 className="hero-title">Gemini para Creación de Imágenes</h1> */}
          <p className="hero-subtitle">
            Descubre cómo utilizar la inteligencia artificial de Google para
            transformar la creación de imágenes y videos en Auteco
          </p>
        </div>
      </section>

      <section  className="section">
      <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
        <div >
         <img  
           ref={image3Ref}
           className={`media-fade-in media-slide-right ${isImage3Visible ? 'visible' : ''}`}
           style={{ width: '35vw', height: 'auto', marginLeft: '50px' }} 
           src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Captura%20de%20pantalla%202025-12-16%20a%20la(s)%207.57.53%E2%80%AFa.m..png" 
           alt="Gemini" 
         />
        </div>
        <video
          ref={videoRef}
          className={`media-fade-in media-scale-up ${isVideoVisible ? 'visible' : ''}`}
          style={{ width: '55vw', height: 'auto' }}
          src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/sample_0.mp4"
          controls
          aria-label="Gemini video"
        >
          <track kind="captions" src="" srcLang="es" label="Español" default />
          Tu navegador no soporta la reproducción de video.
        </video>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <img
            ref={image1Ref}
            className={`media-fade-in ${isImage1Visible ? 'visible' : ''}`}
            style={{ width: '55vw', height: 'auto'}}
            src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/up-760d114d-ac8a-4019-bc5c-6772ecb4321b.png"
            alt="Gemini"
            
          />
          <div>
          <img 
            ref={image2Ref}
            className={`media-fade-in media-slide-left ${isImage2Visible ? 'visible' : ''}`}
            style={{ width: '35vw', height: 'auto', marginRight: '50px'  }} 
            src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Captura%20de%20pantalla%202025-12-16%20a%20la(s)%207.53.07%E2%80%AFa.m..png" 
            alt="Gemini" 
          />

          </div>
        </div>
       
      </section>

      {/* Main Content */}
      <div className="main-container">
        {/* PDF Viewer Section */}
        <section className="section">
          <div className="card pdf-card">
            <div className="card-header">
              <h2 className="card-title">
                Guía de Uso: Creación de Imágenes con Gemini
              </h2>
              <p className="card-description">
                Aprende paso a paso cómo utilizar Gemini para generar imágenes
                innovadoras
              </p>
            </div>
            <div
              className="pdf-container"
              style={{
                marginTop: '40px',
                marginBottom: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <iframe
                style={{ width: '60vw', height: '37vw' }}
                className="pdf-viewer"
                src="https://docs.google.com/presentation/d/e/2PACX-1vSYcRRRYixeXsFxbVunYgH76iuehgQUHziJfa-58wCHsPVe6uWrnHRS32TVYqcREkiOcq39WR5yd1zQ/pubembed?start=false&loop=false&delayms=3000" 
                frameBorder="0"
                allowFullScreen
                title="Guía de Gemini para creación de imágenes"
              />
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="section">
          <div className="card form-card">
            <div className="card-header">
              <h2 className="card-title">Comparte tu Idea</h2>
              <p className="card-description">
                ¿Tienes una idea de cómo implementar Gemini en tu área?
                Compártela con nosotros y trabajemos juntos para hacerla
                realidad.
              </p>
            </div>
            <div className="form-container">
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSf-4eHPMXF6_TbDpXUTOhhYJimUQwdMwBsXVwiTtKosD50Yag/viewform?embedded=true"
                className="google-form-iframe"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Formulario de ideas para Gemini"
              >
                Cargando…
              </iframe>
            </div>
          </div>
        </section>
        <br />
        <br />
        <br /> <br />
        <br />
        <br />

        {/* Google Tools Section */}
        <section className="section">
          <div className="tools-section-header">
            <h2 className="tools-section-title">Herramientas Recomendadas</h2>
            <p className="tools-section-subtitle">
              Experimenta usando los últimos modelos de IA
            </p>
          </div>
          <div className="tools-grid">
            <div className="tool-card">
              <div className="tool-image-container">
                <img
                  src="https://www.gstatic.com/lamda/images/gemini_aurora_thumbnail_4g_e74822ff0ca4259beb718.png"
                  alt="Gemini"
                  className="tool-image"
                />
              </div>
              <div className="tool-content">
                <h3 className="tool-title">Gemini</h3>
                <p className="tool-description">
                  Gemini es un modelo de IA multimodal avanzado que puede
                  entender y generar texto, imágenes, audio y más. Explora las
                  capacidades de creación de imágenes con IA.
                </p>
                <a
                  href="https://gemini.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tool-button"
                >
                  Conocer más
                </a>
              </div>
            </div>

            <div className="tool-card">
              <div className="tool-image-container">
                <img
                  src="https://ai.google.dev/static/site-assets/images/share-ais-03.png"
                  alt="Google AI Studio"
                  className="tool-image"
                />
              </div>
              <div className="tool-content">
                <h3 className="tool-title">Google AI Studio</h3>
                <p className="tool-description">
                  Plataforma de Google para probar, diseñar y prototipar
                  aplicaciones con modelos de inteligencia artificial generativa
                  de forma rápida y visual.{' '}
                </p>
                <a
                  href="https://aistudio.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tool-button"
                >
                  Conocer más
                </a>
              </div>
            </div>

            <div className="tool-card">
              <div className="tool-image-container">
                <img
                  src="https://miro.medium.com/v2/da:true/resize:fit:1200/0*hhsk4tfyjibSPtu7.gif"
                  alt="Imagen 3"
                  className="tool-image"
                />
              </div>
              <div className="tool-content">
                <h3 className="tool-title">Google Labs</h3>
                <p className="tool-description">
                  Espacio donde Google presenta y prueba experimentalmente
                  nuevas tecnologías y funciones, especialmente de inteligencia
                  artificial, antes de lanzarlas oficialmente.
                </p>
                <a
                  href="https://labs.google"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tool-button"
                >
                  Probar ahora
                </a>
              </div>
            </div>

            <div className="tool-card">
              <div className="tool-image-container">
                <img
                  src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Captura%20de%20pantalla%202025-12-17%20a%20la(s)%207.29.32%E2%80%AFa.m..png"
                  alt="Imagen 3"
                  className="tool-image"
                />
              </div>
              <div className="tool-content">
                <h3 className="tool-title">Google Vids</h3>
                <p className="tool-description">
                Aplicación de creación de videos impulsada por IA para el trabajo
                </p>
                <a
                  href="https://workspace.google.com/intl/es-419/products/vids/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tool-button"
                >
                  Probar ahora
                </a>
              </div>
            </div>
          </div>
        </section>
        <br />
        <br />
        <br /> <br />
        <br />
        <br />
          {/* Google Tools Section */}
          <section className="section">
          <div className="tools-section-header">
            <h2 className="tools-section-title">Gemas personalizadas</h2>
            <p style={{ padding: '0 5vw' }} className="tools-section-subtitle">
            En Gemini, una gema es un complemento o extensión personalizada que se le agrega al modelo para especializar su comportamiento en una tarea o contexto específico. Hemos creado  gemas personalizadas para la creación de imágenes y videos en Auteco.
            </p>
          </div>
          <div className="gem-cards-grid">
            <div style={{ background: '#8778cb' }} className="gem-card gem-card-blue">
              <div className="gem-card-image-container">
                <div className="gem-card-image-mask">
                  <img
                    src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Sin%20ti%CC%81tulo-2.png"
                    alt="Gema de Imágenes"
                    className="gem-card-image"
                  />
                </div>
              </div>
              <div style={{ background: '#8778cb' }} className="gem-card-content">
                <h3 style={{ color: 'black', fontWeight: 'bold' }} className="gem-card-title">Gema de Videos</h3>
                <p style={{ color: 'black' }} className="gem-card-description">
                Gema personalizada especializada en la creación de videos con IA. 
                Diseñada para generar contenido de video innovador y profesional para Auteco.
                </p>
                <a
                  href="https://gemini.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                 <button style={{ background: '#8778cb', color: 'black' }} type="button" className="gem-card-button">
                  Probar ahora
                </button>
                </a>
                
              </div>
            </div>

            <div className="gem-card gem-card-blue">
              <div className="gem-card-image-container">
                <div className="gem-card-image-mask">
                  <img
                    src="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Sin%20ti%CC%81tulo-3.png"
                    alt="Gema de Videos"
                    className="gem-card-image"
                  />
                </div>
              </div>
              <div className="gem-card-content">
                <h3 style={{ color: 'black', fontWeight: 'bold' }} className="gem-card-title">Gema de Imágenes</h3>
                <p style={{ color: 'black' }} className="gem-card-description">
                  
                  Gema personalizada especializada en la creación de imágenes con IA. 
                  Optimizada para generar imágenes de alta calidad adaptadas a las necesidades de Auteco.
                </p>
                <a
                  href="https://gemini.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                <button style={{ background: '#5d9bff', color: 'black' }} type="button" className="gem-card-button">
                  Probar ahora
                </button>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Downloads Section */}

        <section className="section">
          <div className="card downloads-card">
            <div className="card-header">
              <h2 className="card-title">
                <span className="icon">📥</span>
                Documentos de ejemplo
              </h2>
              <p className="card-description">
                Descarga documentos de trabajo de ejemplo
              </p>
            </div>
            <div className="downloads-grid">
              <div className="download-item" role="button" tabIndex={0}>
                <div className="download-icon">📄</div>
                <h3 className="download-title">
                  Documento de Pre-Liquidación Aduanera
                </h3>
                <p className="download-description">
                  Documento de ejemplo para pre-liquidación aduanera
                </p>
                <a
                  href="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/DOCUMENTO%20DE%20PRE-LIQUIDACIO%CC%81N%20ADUANERA%20(1)%20(2).pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button type="button" className="download-button">
                    Abrir
                  </button>
                </a>
              </div>
              <div className="download-item">
                <div className="download-icon">📊</div>
                <h3 className="download-title">Tabla Demo Mercado</h3>
                <p className="download-description">
                  Tabla de ejemplo para análisis de mercado
                </p>
                <a
                  href="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Tabla%20Demo%20Mercado%20(1).xlsx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button type="button" className="download-button">
                    Abrir
                  </button>
                </a>
              </div>
              <div className="download-item">
                <div className="download-icon">📊</div>
                <h3 className="download-title">Tabla Simulada de Fletes</h3>
                <p className="download-description">
                  Tabla de ejemplo para simulación de fletes
                </p>
                <a
                  href="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Tabla%20simulada%20de%20fletes.xlsx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button type="button" className="download-button">
                    Abrir
                  </button>
                </a>
              </div>
              <div className="download-item">
                <div className="download-icon">📊</div>
                <h3 className="download-title">
                  Tabla Simulada de Inventario de Repuestos
                </h3>
                <p className="download-description">
                  Tabla de ejemplo para inventario de repuestos de moto
                </p>
                <a
                  href="https://storage.googleapis.com/lucia-static/media/docs%20gemini%20ex/Tabla%20simulada%20de%20inventario%20de%20repuestos%20de%20moto...%20(3).xlsx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button type="button" className="download-button">
                    Abrir
                  </button>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default GeminiPage
